import styled from 'styled-components';
import { formatCurrency } from '@/shared/libs/format-currency';
import { BodyTextMediumB, BodyTextRegularC } from '@/shared/ui/typography2';
import { Image } from '@/shared/ui/image';
import { useRouter } from 'next/navigation';
import { processText } from '@/shared/libs/process-text';
import { useCurrentLocale } from '@locales/client';

export function WinItem(props: {
  item: {
    bet: number;
    date: number;
    game: number;
    imageUrl: any;
    factor: number;
    title: any;
    userName: string;
    user: string;
    win: number;
  };
  currency: string;
  currencySymbol: string;
  columnIndex: number;
  columnKey: string;
}) {
  const router = useRouter();
  const locale = useCurrentLocale();
  const winValue = formatCurrency(props.item.win, {
    currency: props.currency,
    currencySymbol: props.currencySymbol,
  });
  const factorValue = `×${Math.round(100 * props.item.factor) / 100}`;

  const getGameInfoPath = (game, demo = false) => {
    const { providerId, title,code } = game;
    return `/${locale}/games/${processText(providerId)}/${code||processText(title)}`;
  };

  const onClickHandler = () => {
    router.push(getGameInfoPath(props.item.game));
  };

  return (
    <Item onClick={onClickHandler}>
      <ItemIcon
        src={props.item.imageUrl}
        width={48}
        height={48}
        alt="game icon"
        style={{ objectFit: 'cover' }}
      />
      <TitlesContainer>
        <ItemTitle>{props.item.title}</ItemTitle>
        <BodyTextRegularC>{props.item.userName}</BodyTextRegularC>
      </TitlesContainer>
      <ValuesContainer>
        <BodyTextMediumB
          color={props.columnIndex % 2 === 0 ? '#34C759' : '#FF6601'}
        >
          {props.columnKey !== 'topFactor' ? winValue : factorValue}
        </BodyTextMediumB>
        <BodyTextRegularC>
          {props.columnKey === 'topFactor' ? winValue : factorValue}
        </BodyTextRegularC>
      </ValuesContainer>
    </Item>
  );
}

const Item = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  height: 60px;
  padding: 6px 12px 6px 6px;
  border-radius: 8px;
  background: #27262b;
  gap: 12px;
  cursor: pointer;
`;
const ItemIcon = styled(Image)`
  object-fit: contain;
  border-radius: 8px;
`;
const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;
const TitlesContainer = styled(RowContainer)`
  align-items: flex-start;
  min-width: 0;
`;
const ItemTitle = styled(BodyTextMediumB)`
  justify-content: flex-start;
  white-space: nowrap;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  overflow-x: hidden;

  max-width: 100%;
`;
const ValuesContainer = styled(RowContainer)`
  align-items: flex-end;
`;
